<template>
  <div class="pa-6">
    <v-card elevation="2">
      
      <v-menu offset-y :close-on-content-click="false" max-height="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="ml-2 my-2" depressed color="primary" :loading="categoriesState.isLoading">
            <span>Создать</span>
            <v-icon class="ml-2" small>mdi-plus-circle-outline</v-icon>
          </v-btn>

          <v-btn class="ml-4 my-2 mr-2" depressed color="primary" @click="isUploadOpen = true">
            <span>Загрузить</span>
            <v-icon class="ml-2" small>mdi-cloud-upload-outline</v-icon>
          </v-btn>
        </template>
        <v-sheet max-width="750">
          <!-- search -->
          <text-field class="pa-3 mb-0" name="Поиск" :value.sync="medrecordsTemplatesSearch" afterIcon="mdi-magnify"/>
          <v-list v-if="medrecordsTemplatesSearch&&medrecordsTemplatesSearch.length">
            <v-list-item v-for="medRecordTemplate in medRecordsTemplatesFilter" :key="'s-medRecordTemplate_'+medRecordTemplate.id" @click="medRecordCreate(medRecordTemplate.id)">
              <v-list-item-title class="body-2 pl-2">{{ medRecordTemplate.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <!-- search end-->
          <template v-else>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="category in medRecordTemplateCategories" :key="'categories_'+category.id">
                <v-expansion-panel-header class="font-weight-medium">{{ category.name }}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-if="category.medRecordTemplatecategories.length===0" class="text-center caption pa-1">Не найдено</div>
                  <v-expansion-panels v-if="category.medRecordTemplatecategories.length>1" accordion class="expansionPanelContentExpanded">
                    <v-expansion-panel v-for="medRecordTemplateCategory in category.medRecordTemplatecategories" :key="'categories1_'+medRecordTemplateCategory.id">
                      <v-expansion-panel-header class="font-weight-medium">{{ medRecordTemplateCategory.name }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-list>
                          <v-list-item v-for="medRecordTemplate in medRecordTemplateCategory.medRecordTemplates" :key="'medRecordTemplate_'+medRecordTemplate.id" @click="medRecordCreate(medRecordTemplate.id)">
                            <v-list-item-title class="body-2 pl-2">{{ medRecordTemplate.name }}</v-list-item-title>
                          </v-list-item>
                          <div v-if="medRecordTemplateCategory.medRecordTemplates.length===0" class="text-center caption pa-1">Не найдено</div>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <template v-else>
                    <template v-for="medRecordTemplateCategory in category.medRecordTemplatecategories" >
                        <v-list v-if="medRecordTemplateCategory.medRecordTemplates" :key="'categories1_'+medRecordTemplateCategory.id">
                          <v-list-item v-for="medRecordTemplate in medRecordTemplateCategory.medRecordTemplates" :key="'medRecordTemplate_'+medRecordTemplate.id" @click="medRecordCreate(medRecordTemplate.id)">
                            <v-list-item-title class="body-2 pl-2">{{ medRecordTemplate.name }}</v-list-item-title>
                          </v-list-item>
                          <div v-if="medRecordTemplateCategory.medRecordTemplates.length===0" class="text-center caption pa-1">Не найдено</div>
                        </v-list>               
                    </template>
                  </template>

                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
        </v-sheet>
      </v-menu>
     
      <v-menu offset-y :close-on-content-click="false" max-height="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="ml-2 my-2" depressed color="primary" :loading="categoriesState.isLoading || mediaCreateState.isLoading">
            <span>Создать из документа</span>
            <v-icon class="ml-2" small>mdi-plus-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-sheet max-width="750">
          <!-- search -->
          <text-field class="pa-3 mb-0" name="Поиск" :value.sync="mediaTemplatesSearch" afterIcon="mdi-magnify"/>
          <v-list v-if="mediaTemplatesSearch&&mediaTemplatesSearch.length">
            <v-list-item v-for="mediaTemplate in mediaTemplatesFilter" :key="'s-mediaTemplate_'+mediaTemplate.id" @click="mediaCreateAction(mediaTemplate.id)">
              <v-list-item-title class="body-2 pl-2">{{ mediaTemplate.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
          <!-- search end-->
          <template v-else>
            <MediaCategoryPanel
                :categories="mediaTemplateCategories"
                @create="mediaCreateAction"
              />
            <v-list v-if="mediaTemplatesWithoutCat.length">
              <v-divider/>
              <v-list-item v-for="mediaTemplate in mediaTemplatesWithoutCat" :key="'mediaTemplate_'+mediaTemplate.id" @click="mediaCreateAction(mediaTemplate.id)">
                <v-list-item-title class="body-2 pl-2">{{ mediaTemplate.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </template>
        </v-sheet>
      </v-menu>


      <v-data-table
          :headers="headers"
          :items="medRecords"         
          :loading="loadState.isLoading"
          dense
          :height="height"
          disable-pagination
          hide-default-footer
      >
        <template v-slot:item="{ item }">
          
          <tr @click="typeof item.medRecordTemplate !== 'undefined' ? medRecordId=item.id : mediaId=item.id">
            <td class="text-no-wrap">{{item.id}}</td>
            <td class="text-no-wrap">
              <big-text width="600" height="32" :text="item.name!=null&&item.name!='' ? item.name : typeof item.medRecordTemplate !== 'undefined' ? item.medRecordTemplate.name : '-'"/>
              <tooltip v-if="(typeof item.medRecordTemplate === 'undefined')" right>
                 <v-icon  small class="ml-1">mdi-file-document-outline</v-icon>
                <template v-slot:content>
                  Документ
                </template>
              </tooltip>
              <tooltip v-if="item.status==='unactive'" right>
                <v-icon small class="ml-2">mdi-file-alert</v-icon>
                <template v-slot:content>
                  Черновик
                </template>
              </tooltip>
              <tooltip v-if="!item.isShowInService" right>
                <v-icon v-if="!item.isShowInService" class="ml-2" size="14" color="primary">mdi-eye-off-outline</v-icon>
                <template v-slot:content>
                  Скрыто в личном кабинете
                </template>
              </tooltip>
            </td>
            <td>{{item.comment}}</td>
            <td class="text-no-wrap">
              <div v-if="misDesktopOnline&&typeof item.medRecordTemplate === 'undefined'">
                <v-btn small depressed @click.stop="misDesktopOpenFile(item)"><v-icon class="mr-2" small>mdi mdi-open-in-new</v-icon>Открыть локально</v-btn>
              </div>
            </td>
            <td class="text-no-wrap">
              <UserFullName :user="item.userAuthor" type="spec" avatar/>
            </td>
            <td class="text-no-wrap">{{$tools.dateTime(item.created)}}</td>
            <td class="text-no-wrap">
              <chip v-if="item.isSent" color="green" dark small fullWidth>Отправлено</chip>
            </td>
            <td>
                <MediaActions :item="item" :loading="loadState.isLoading" @load="load()" @mediaPreview="(v)=>mediaId=v"/>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <med-record-update :med-record-id.sync="medRecordId" @medRecordCopied="medRecordCopied" :userId="$router.currentRoute.params.id"/>

    <media-view :media-id.sync="mediaId" :user-id="$router.currentRoute.params.id" :userName="userName" @updateList="load()"/>

    <uploader
        :dialog.sync="isUploadOpen"
        :multiple="true"
        :url="'/api/media/media/upload/?mediaDirId=2&userId='+$router.currentRoute.params.id"
        @uploadComplete="uploadComplete"
    />
  </div>
</template>

<script>
import State from "@/plugins/state";
import Api from "@/Api";
import MedRecordUpdate from "@/views/MedRecord/MedRecordUpdate";
import MediaView from "@/views/Media/MediaView";
import Uploader from "@/components/Uploader";
import axios from "axios";
import TextField from "@/componentsV2/base/TextField.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import Chip from "@/componentsV2/base/Chip.vue";
import MediaActions from "@/componentsV2/base/MediaActions.vue";


import {
  Entity_MedRecord,
  Entity_MedRecordTemplateCategory,
  Entity_Spec,
  Entity_MedRecordTemplate,
  Entity_MediaTemplateCategory,
  Entity_MediaTemplate,
  Entity_Media,
  Entity_User,
  Entity_MediaDir
} from "../../../../EntityStoreCacheService";
import BigText from "@/componentsV2/custom/BigText.vue";
import MediaCategoryPanel from "@/views/Media/components/MediaCategoryPanel.vue";

export default {
  components: {
    BigText,
    MedRecordUpdate, 
    MediaView, 
    Uploader, 
    TextField,
    UserFullName,
    Tooltip,
    Chip,
    MediaActions,
    MediaCategoryPanel
  },
  props:['userName'],
  data: () => ({
    categoriesState: new State(),
    medRecordTemplateCategories: [],
    headers: [
      { text: 'ID', value: 'id', sortable: true, class:'text-no-wrap', width:'auto'},
      { text: 'Название', value: 'medRecordTemplate.name', sortable: true, class:'text-no-wrap'},
      { text: 'Комментарий', sortable: false},
      { text: '', sortable: false},
      { text: 'Автор', value: 'userAuthor', sortable: false, class:'text-no-wrap'},
      { text: 'Дата создания', value: 'created', sortable: true, class:'text-no-wrap'},
      { text: 'Отправка на Email', sortable: false},
      { text: '', sortable: false},
    ],
    loadState: new State(),
    mediaRecordCreateState: new State(),
    medRecords:[],
    medRecordId:null,
    medias: [],
    mediaId: null,
    isUploadOpen: false,
    height:null,

    mediaTemplateCategories: [],
    mediaCreateState: new State(),
    mediaCreateErrorState: new State(),

    misDesktopOnline:false,

    medrecordsTemplatesSearch:null,
    medRecordTemplates:[],

    mediaTemplatesWithoutCat: [],
    mediaTemplates: [],
    mediaTemplatesSearch: null

  }),
  mounted() {
    this.height = window.innerHeight - 200-12;
    this.loadTemplatesCategories();
    this.$tools.misDesktopStatus((v)=>{
      this.misDesktopOnline = v;
    });
  },
  computed: {
   
    mediaTemplatesFilter(){
      return this.mediaTemplates.filter(i=>i.name.toLowerCase().includes(this.mediaTemplatesSearch));
    },
    medRecordsTemplatesFilter(){
      return this.medRecordTemplates.filter(i=>i.name.toLowerCase().includes(this.medrecordsTemplatesSearch));
    }
  },
  watch: {
    medRecordId(){
      if (this.medRecordId===null)
      this.load();
    }
  },
  methods:{
    loadTemplatesCategories(){
      this.categoriesState.stateLoading();
      let medRecordTemplateCategory = new Entity_MedRecordTemplateCategory()
      .selects(Entity_MedRecordTemplateCategory.id)
      .selects(Entity_MedRecordTemplateCategory.name)
      .selects(Entity_MedRecordTemplateCategory.status)

      .selects([Entity_MedRecordTemplateCategory.spec, Entity_Spec.id].join('.'))
      .selects([Entity_MedRecordTemplateCategory.spec, Entity_Spec.name].join('.'))

      .selects([Entity_MedRecordTemplateCategory.medRecordTemplates, Entity_MedRecordTemplate.id].join('.'))
      .selects([Entity_MedRecordTemplateCategory.medRecordTemplates, Entity_MedRecordTemplate.name].join('.'))
      .selects([Entity_MedRecordTemplateCategory.medRecordTemplates, Entity_MedRecordTemplate.status].join('.'))
      .selects([Entity_MedRecordTemplateCategory.medRecordTemplates, Entity_MedRecordTemplate.sort].join('.'))

      //filter by status
      .filterAnd([Entity_MedRecordTemplateCategory.entity, Entity_MedRecordTemplateCategory.status].join('.')+'=?','active')

      .page(1).onPage(3000)

      medRecordTemplateCategory.request((data)=>{      

        this.medRecordTemplates = [];
        console.log(this.medRecordTemplates);

        let mainCategories = [...new Map(data.items.map(i => i.spec).map(item => [item.id, item])).values()];

        mainCategories.sort((a, b) => a.name.localeCompare(b.name));

        mainCategories.forEach(cat=>{
          data.items.forEach(i=>{
            if(i.spec.id===cat.id){
              if (!('medRecordTemplatecategories' in cat)) {
                cat.medRecordTemplatecategories = [];
              }
              let medRecordTemplates = i.medRecordTemplates.filter(i=>i.status==='active').sort((a, b) => a.sort - b.sort)
              cat.medRecordTemplatecategories.push({id:i.id,name:i.name,status:i.status,medRecordTemplates:medRecordTemplates})
              cat.medRecordTemplatecategories.sort((a, b) => a.name.localeCompare(b.name));

              this.medRecordTemplates = [...this.medRecordTemplates, ...medRecordTemplates];//список шаблонов для поиска 
            }
          });
        });

        this.medRecordTemplateCategories = mainCategories;
        this.load();
      }, (e)=>{
        console.error(e.response.data.message);
        this.categoriesState.stateError();
      })

      //mediaTemplateCategory
      let mediaTemplateCategory =  new Entity_MediaTemplateCategory()
      .selects(Entity_MediaTemplateCategory.id)
      .selects(Entity_MediaTemplateCategory.name)
      .selects(Entity_MediaTemplateCategory.status)


      //mediaTemplate
      .selects([Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.id].join('.'))
      .selects([Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.name].join('.'))
      .selects([Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.sort].join('.'))
      //.selects([Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.comBranch, Entity_ComBranch.id].join('.'))
      

      //subcategories
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.id].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.name].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.status].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.sort].join('.'))

      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.id].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.name].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.status].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.sort].join('.'))
     
      //subcategory mediaTemplates
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.id].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.name].join('.'))
      //.selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.comBranch, Entity_ComBranch.id].join('.'))

      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.id].join('.'))
      .selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.name].join('.'))
      //.selects([Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.subcategories, Entity_MediaTemplateCategory.mediaTemplates, Entity_MediaTemplate.comBranch, Entity_ComBranch.id].join('.'))

      .page(1).onPage(3000)

      .order(Entity_MediaTemplateCategory.name, true)
   
      //filter by status
      .filterAnd([Entity_MediaTemplateCategory.entity, Entity_MediaTemplateCategory.status].join('.')+'=?','active')

      //filter by parent
      .filterAnd([Entity_MediaTemplateCategory.entity, Entity_MediaTemplateCategory.parentCategory].join('.')+' is null')
  
      //filter by MediaDir
      .filterAnd([Entity_MediaTemplateCategory.entity, Entity_MediaTemplateCategory.mediaDir, Entity_MediaDir.id].join('.')+' NOT IN (?)',[1])

      mediaTemplateCategory.request((data)=>{
        let mediaCategories = data.items;

        let mediaTemplatesList = [];

        //sort
        function sortMediaTemplates(category) {

          if (category.mediaTemplates) {
              category.mediaTemplates.sort((a, b) => a.sort - b.sort);
          }

          if (category.subcategories && category.subcategories.length > 0) {
              category.subcategories = category.subcategories.map(subcategory => sortMediaTemplates(subcategory));
          }

          mediaTemplatesList = [...mediaTemplatesList, ...category.mediaTemplates];//список шаблонов для поиска  

          return category;
        }

        const sortedData = mediaCategories.map(category => sortMediaTemplates(category));
        this.mediaTemplateCategories = sortedData;
        this.mediaTemplates = mediaTemplatesList;

        //mediaTemplates without cat
        let mediaTemplatesQuery = new Entity_MediaTemplate()
        .selects(Entity_MediaTemplate.id)
        .selects(Entity_MediaTemplate.name)
        .selects(Entity_MediaTemplate.sort)

        .filterAnd([Entity_MediaTemplate.entity, Entity_MediaTemplate.mediaDir, Entity_MediaDir.id].join('.')+' NOT IN (?)',[1,4])//исключаем раздел договоры и справки
        .filterAnd([Entity_MediaTemplate.entity, Entity_MediaTemplate.mediaTemplateCategory].join('.')+' is null')

          mediaTemplatesQuery.page(1).onPage(3000)
          mediaTemplatesQuery.order(Entity_MediaTemplate.sort, true)

    
          mediaTemplatesQuery.request((data)=>{
          this.mediaTemplatesWithoutCat = data.items
          this.mediaTemplates =  [...this.mediaTemplates, ...this.mediaTemplatesWithoutCat];//список шаблонов для поиска 

          this.categoriesState.stateSuccess();
        }, (e)=>{
          console.error(e.response.data.message);
        })
      }, (e)=>{
        console.error(e.response.data.message);
        this.categoriesState.stateError();
      })

    },
    load(){
      this.loadState.stateLoading();

      const promises = [];
      const medRecords = new Promise((resolve) => {  
        let medRecordRequest = new Entity_MedRecord()
          .selects(Entity_MedRecord.id)
          .selects(Entity_MedRecord.created)
          .selects(Entity_MedRecord.isSent)
          .selects(Entity_MedRecord.isPrinted)
          .selects(Entity_MedRecord.isShowInService)
          .selects(Entity_MedRecord.name)
          .selects(Entity_MedRecord.status)
          .selects(Entity_MedRecord.comment)
       

          //user
          .selects([Entity_MedRecord.user,Entity_User.id].join('.'))
          .selects([Entity_MedRecord.user,Entity_User.firstName].join('.'))
          .selects([Entity_MedRecord.user,Entity_User.lastName].join('.'))
          .selects([Entity_MedRecord.user,Entity_User.secondName].join('.'))

          //user author
          .selects([Entity_MedRecord.userAuthor, Entity_User.id].join('.'))
          .selects([Entity_MedRecord.userAuthor, Entity_User.firstName].join('.'))
          .selects([Entity_MedRecord.userAuthor, Entity_User.lastName].join('.'))
          .selects([Entity_MedRecord.userAuthor, Entity_User.secondName].join('.'))
          .selects([Entity_MedRecord.userAuthor, Entity_User.imageUrl].join('.'))

          //medRecordTemplate
          .selects([Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.id].join('.'))
          .selects([Entity_MedRecord.medRecordTemplate, Entity_MedRecordTemplate.name].join('.'))

          .filterAnd([Entity_MedRecord.entity, Entity_MedRecord.user, Entity_User.id ].join('.')+' =?',this.$router.currentRoute.params.id)
          .filterAnd([Entity_MedRecord.entity, Entity_MedRecord.status].join('.')+'!=?','deleted')


          .page(1).onPage(10000)

          medRecordRequest.request((data)=>{
              resolve(data.items);
          }, (e)=>{
            console.error(e.response.data.message);
          })
      });

      promises.push(medRecords);

      const media = new Promise((resolve) => {
        let mediaRequest = new Entity_Media()
        .selects(Entity_Media.id)
        .selects(Entity_Media.created)
        .selects(Entity_Media.isSent)
        .selects(Entity_Media.isPrinted)
        .selects(Entity_Media.isShowInService)
        .selects(Entity_Media.name)
        .selects(Entity_Media.status)
        .selects(Entity_Media.fileName)
        .selects(Entity_Media.type)
        .selects(Entity_Media.path)
      

        //user
        .selects([Entity_Media.user,Entity_User.id].join('.'))
        .selects([Entity_Media.user,Entity_User.firstName].join('.'))
        .selects([Entity_Media.user,Entity_User.lastName].join('.'))
        .selects([Entity_Media.user,Entity_User.secondName].join('.'))

        //user
        .selects([Entity_Media.userAuthor, Entity_User.id].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.firstName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.lastName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.secondName].join('.'))
        .selects([Entity_Media.userAuthor, Entity_User.imageUrl].join('.'))


        .filterAnd([Entity_Media.entity, Entity_Media.user, Entity_User.id ].join('.')+' =?',this.$router.currentRoute.params.id)
        .filterAnd([Entity_Media.entity, Entity_Media.mediaDir, Entity_MediaDir.id ].join('.')+' NOT IN (?)',[1,4])//исключаем раздел договоры и справки
        .filterAnd([Entity_Media.entity, Entity_Media.status].join('.')+'!=?','deleted')

        .page(1).onPage(10000)

        mediaRequest.request((data)=>{
            resolve(data.items);
        }, (e)=>{
          console.error(e.response.data.message);
        })
      });
      promises.push(media);


      Promise.all(promises).then((result) => {
        let medRecordsAndMedia = [];
        result.forEach(arr=>{
          medRecordsAndMedia = medRecordsAndMedia.concat(arr);
        })

        //sort by created
        let sortedArray = medRecordsAndMedia.slice().sort(function(a, b) {
            return new Date(b.created) - new Date(a.created);
        });


        this.medRecords = sortedArray;

        this.loadState.stateSuccess();
      }).catch((error) => {
        console.error('Error:', error);
        this.loadState.stateError(error)
      }); 
          
    },
    medRecordCreate(medRecordTemplateId){
      this.mediaRecordCreateState.stateLoading();
      Api.service.medRecord.medRecordCreate(medRecordTemplateId, this.$router.currentRoute.params.id, (data)=>{
        this.mediaRecordCreateState.stateSuccess();
        this.medRecordId = data.id;
        this.loadTemplatesCategories();
      }, ()=>{
        this.mediaRecordCreateState.stateError();
      });
    },
    medRecordCopied(id){
      this.loadTemplatesCategories();
      this.medRecordId = id;
    },
    uploadComplete(){
      this.loadTemplatesCategories();
    },
    mediaCreateAction(mediaTemplateId){
      this.mediaCreateState.stateLoading();
      axios.post(Api.host+'/media/mediaTemplate/'+mediaTemplateId+'/mediaCreate/', {
        userId:this.$router.currentRoute.params.id
      })
          .then(r=>{
            this.mediaCreateState.stateSuccess();
            this.loadTemplatesCategories();
            this.$tools.misDesktopStatus((v)=>{
              if(v){
                this.$tools.misDesktopOpenFile(
                    r.data.path,
                    r.data.name + r.data.path.substring(r.data.path.lastIndexOf('.')),
                    "https://"+window.location.hostname+"/api/media/media/upload/desktop/",
                    {id: r.data.id},
                    ()=>{
                      this.$store.commit('alertSuccess', 'Файл открывается локально');
                    }, ()=>{
                      this.$store.commit('alertError', 'Не удалось открыть файл локально');
                    }
                );
              } else {
                this.mediaId = r.data.id;
              }
            });
          })
          .catch((e)=>{
            console.log(e);
            this.mediaCreateState.stateError();
          });
    },
    misDesktopOpenFile(v){
      axios.get(Api.host + '/media/media/' + v.id + '/').then(r1 => {
        let mediaData = r1.data;
        this.$tools.misDesktopOpenFile(
            mediaData.path,
            mediaData.name + mediaData.path.substring(mediaData.path.lastIndexOf('.')),
            "https://"+window.location.hostname+"/api/media/media/upload/desktop/",
            {
              id: v.id,
            },
            ()=>{
              this.$store.commit('alertSuccess', 'Файл открывается локально');
            }, ()=>{
              this.$store.commit('alertError', 'Не удалось открыть файл локально');
            }
        );
      });
    },
  }
}
</script>